import type { ReactElement, SVGProps } from 'react'

/**
 * RouteBadge pin body (50 × 56) — rounded body + down-arrow tip whose
 * point lands at the station coordinate.
 *
 * Path data byte-identical to
 * `metro/docs/superpowers/specs/assets/routecard-v2/route-badge.svg`
 * (Figma export). The body fill is bound to `currentColor` so the
 * RouteBadge can tint it per line color (line color is DATA, not a
 * token — set `color: <lineHex>` on the wrapper).
 */
export function IconRouteBadgeBody(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      viewBox="0 0 50 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path
        d="M11.33 0H38.67C41.6749 0 44.5567 1.19369 46.6815 3.31848C48.8063 5.44327 50 8.3251 50 11.33V36.67C50 39.6749 48.8063 42.5567 46.6815 44.6815C44.5567 46.8063 41.6749 48 38.67 48H33L25 56L17 48H11.33C8.3251 48 5.44327 46.8063 3.31848 44.6815C1.19369 42.5567 0 39.6749 0 36.67L0 11.33C0 8.3251 1.19369 5.44327 3.31848 3.31848C5.44327 1.19369 8.3251 0 11.33 0Z"
        fill="currentColor"
      />
    </svg>
  )
}
